import React, { useState } from 'react';

export default function SeguimientoModal({ caso, onClose, onGuardar }) {
  const [nota, setNota] = useState('');
  const [destinatario, setDestinatario] = useState(caso.destinatario || '');
  const [estado, setEstado] = useState(caso.estado || 'En proceso');
  const [fechaAlerta, setFechaAlerta] = useState(caso.fechaAlerta || '');
  const [saving, setSaving] = useState(false);

  async function handleGuardar() {
    if (!nota.trim()) { alert('Escribe una nota de seguimiento.'); return; }
    setSaving(true);
    const seg = {
      fecha: new Date().toISOString().split('T')[0],
      nota: nota.trim(),
      destinatario,
      estado,
    };
    await onGuardar(caso.id, seg, estado, destinatario, fechaAlerta);
    setSaving(false);
    onClose();
  }

  return (
    <div className="modal-overlay open" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2>Agregar seguimiento</h2>
          <div style={{ fontSize: 13, color: 'var(--gray-500)', marginTop: 2 }}>{caso.centro}</div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Nota de seguimiento *</label>
            <textarea value={nota} onChange={e => setNota(e.target.value)} placeholder="Acción realizada, respuesta recibida, acuerdo establecido..." />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Enviado / Remitido a</label>
              <input value={destinatario} onChange={e => setDestinatario(e.target.value)} placeholder="Instancia o persona" />
            </div>
            <div className="form-group">
              <label>Nuevo estado</label>
              <select value={estado} onChange={e => setEstado(e.target.value)}>
                <option>Recibido</option>
                <option>En proceso</option>
                <option>Orientado</option>
                <option>Cerrado</option>
              </select>
            </div>
          </div>
          <div className="form-group" style={{ maxWidth: 220 }}>
            <label>Nueva fecha límite</label>
            <input type="date" value={fechaAlerta} onChange={e => setFechaAlerta(e.target.value)} />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={handleGuardar} disabled={saving}>
            {saving ? 'Guardando...' : 'Guardar seguimiento'}
          </button>
        </div>
      </div>
    </div>
  );
}